import React from "react"
import ImgLaptop from "./assets/laptop.png"
import xls from "./assets/office-excel.png"
import ppt from "./assets/office-powerpoint.png"
import "./features.scss"

export function Features() {
  return (
    <div className="features">
      <div className="features__container container">
        <div className="features__heading heading" id="features">
          <div className="heading__title">Features</div>
          <div className="heading__subtitle">
            See a short case study of <em>doxpro</em> solutions
          </div>
        </div>
        <div className="m-t-32" style={{position: "relative"}}>
          <div
            style={{
              top: "5%",
              left: "7.7%",
              position: "absolute",
              width: "84.6%",
              height: "83.9%",
              // width: "fit-content",
              // height: "fit-content",
              backgroundColor: "black",
            }}
          >
            {/* <a
              style={{
                position: "absolute",
                top: "20px",
                right: "1rem",
                opacity: 0.8,
              }}
              href="https://clipchamp.com/watch/Z8q8OTuGZP5?utm_source=embed&utm_medium=embed&utm_campaign=watch"
            >
              <img
                loading="lazy"
                style={{height: "22px"}}
                src="https://clipchamp.com/e.svg"
                alt="Made with Clipchamp"
              />
            </a> */}
            <iframe
              allow="autoplay;"
              allowFullScreen={true}
              style={{border: "none"}}
              src="https://clipchamp.com/watch/Z8q8OTuGZP5/embed"
              width="100%"
              height="100%"
            ></iframe>
          </div>
          <img src={ImgLaptop} alt="doxpro app view" />
        </div>
        <div className="row-cols-2 negative-margin-15 flex-wrap m-t-48 hidden">
          <div className="col col-features-pp">
            <h2 className="features__category">PowerPoint</h2>
            <h2 className="features__category p-b-30">
              <span className="inline-block">
                <img src={ppt} alt="PowerPoint Features" />
              </span>
            </h2>
            <section className="feature">
              <h2 className="features__h2">Template Assets Galleries</h2>
              <p className="features__p">
                The core of Doxpro templates is how they represent templates as databases of various assets. Categorized
                asset galleries play a crucial role in providing doxpro users with a way to construct and build a
                document from those assets as bricks. Thus ensuring approved styling and increasing productivity
              </p>
            </section>
            <section className="feature">
              <h2 className="features__h2">Excel Object Linking</h2>
              <p className="features__p">
                When you import objects from Excel, every time object is updated you lose precious time finding a source
                file and manually reinserting and repositioning your object. Doxpro packs those actions into one click
                and additionally provides insertion metadata you can use to identify who and when inserted particular
                object as well as helps position objects on a slide grid automatically
              </p>
            </section>
            <section className="feature">
              <h2 className="features__h2">Automated Contents</h2>
              <p className="features__p">
                One of the core aspirations of Doxpro tooling is streamlining documentation creation process and tools
                like automated contents play an important role in achieving goal. You can freely add slides around and
                see how your table of contents reacts to changes
              </p>
            </section>
            <section className="feature">
              <h2 className="features__h2">Slide Reference Tracking and more…</h2>
              <p className="features__p">
                PowerPoint due to its intended purpose (as digital presenter) is missing a lot of functionality common
                for printed document editors like slide (page) references and so on. Doxpro re-adds that functionality
                into PowerPoint so that you can comfortably work on large reports as usual
              </p>
            </section>
          </div>
          <div className="col col-features-xl">
            <h2 className="features__category">Excel</h2>
            <h2 className="features__category p-b-30">
              <span className="inline-block">
                <img src={xls} alt="Excel Features" />
              </span>
            </h2>
            <section className="feature">
              <h2 className="features__h2">Databook Sheet Templates</h2>
              <p className="features__p">
                Most engagements are based on recurring patterns like data tables, calc layouts and so on. Doxpro offers
                to keep those patterns at hand as sheet templates, so that you&apos;d never start your work from
                scratch. You are expected to update sheet templates as you go through an engagement, to keep them sharp
              </p>
            </section>
            <div className="feature">
              <h2 className="features__h2">Approved Chart Templates</h2>
              <p className="features__p">
                Charts are subject to a design team approval, it relates to chart layout, size, colors and recommended
                types - to use those chart setups Doxpro offers a gallery of recommended charts for a team - which will
                cover all above mentioned concerns
              </p>
            </div>
            <section className="feature">
              <h2 className="features__h2">Automated Table Formatter</h2>
              <p className="features__p">
                To be consistent within a report - a team should use a common, designer approved data table style. But
                creating and applying such a style to your databook ranges is error prone and time consuming. Doxpro
                offers a simple tool which you can use to prepare a range as a table for an insertion into client
                documentation which will save your time and ensure proper styling
              </p>
            </section>
            <section className="feature">
              <h2 className="features__h2">Automated Sheets Index and more…</h2>
              <p className="features__p">
                As your databook grow, navigation can become cumbersome and contents of the databook get hidden which in
                case if you send your databook to a client is not quite presentable. To tackle that problem Doxpro
                provides an automated sheets index which enables a quick overview of your book contents as well we easy
                navigation between sheets
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
